export const restockingOfficeMockData = [
    {
        "id": 35340,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 1,
        "low_quantity_alert": true,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5142,
            "name": "Air Conditioner",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 414,
                "name": "Air Conditioner",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35339,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 1,
        "low_quantity_alert": true,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5141,
            "name": "Refrigerator",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 413,
                "name": "Refrigerator",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35342,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Microwave",
        "min_quantity": 4,
        "current_quantity": 5,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 10005,
            "name": "Microwave",
            "model": null,
            "kind": "specific",
            "category": {
                "id": 599,
                "name": "Microwave",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
                "room_categories": [
                    "front-yard",
                    "bathroom",
                    "laundry",
                    "front_yard",
                    "garage",
                    "bedroom",
                    "backyard",
                    "back_yard",
                    "living_room",
                    "hallway",
                    "stairwell",
                    "kitchen",
                    "reception_area",
                    "patio",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35343,
        "inventory_settings": { "strategies": [{ "type": "auto", "amount_per_reservation": 2 }] },
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Mug",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5637,
            "name": "Mug",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 417,
                "name": "Mug",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/hot-drink.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35350,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5358,
            "name": "Air Conditioner",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 251,
                "name": "Air Conditioner",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
                "room_categories": []
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35355,
        "inventory_settings": { "strategies": [{ "type": "auto", "amount_per_reservation": 1 }] },
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Toaster",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 6766,
            "name": "Toaster",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 517,
                "name": "Toaster",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/toaster (1).svg",
                "room_categories": [
                    "kitchen",
                    "office",
                    "reception_area",
                    "main_workspace",
                    "dining-room"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35341,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Microwave",
        "min_quantity": 4,
        "current_quantity": 5,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 7623,
            "name": "Microwave",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 599,
                "name": "Microwave",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
                "room_categories": [
                    "front-yard",
                    "bathroom",
                    "laundry",
                    "front_yard",
                    "garage",
                    "bedroom",
                    "backyard",
                    "back_yard",
                    "living_room",
                    "hallway",
                    "stairwell",
                    "kitchen",
                    "reception_area",
                    "patio",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35344,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "TV",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 4448,
            "name": "TV",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 248,
                "name": "TV",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": []
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35345,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Table",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 4954,
            "name": "Table",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 249,
                "name": "Table",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/table.svg",
                "room_categories": []
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35346,
        "inventory_settings": { "strategies": [{ "type": "auto", "amount_per_reservation": 2 }] },
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Glass / Cup",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5600,
            "name": "Glass / Cup",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 416,
                "name": "Glass / Cup",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/glass-of-water.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35347,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Microwave",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5020,
            "name": "Microwave",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 428,
                "name": "Microwave",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35348,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "TV",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5392,
            "name": "TV",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 429,
                "name": "TV",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35349,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Monitor",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5840,
            "name": "Monitor",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 424,
                "name": "Monitor",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35351,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Monitor",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 10006,
            "name": "Monitor",
            "model": null,
            "kind": "specific",
            "category": {
                "id": 250,
                "name": "Monitor",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": []
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35353,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Table",
        "min_quantity": 4,
        "current_quantity": 5,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5316,
            "name": "Table",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 250,
                "name": "Table",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/table.svg",
                "room_categories": []
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35354,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Coffee Pot Coffee Maker",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 10008,
            "name": "Coffee Pot Coffee Maker",
            "model": "Coffee Maker",
            "kind": "specific",
            "category": {
                "id": 516,
                "name": "Coffee Pot",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/coffee-pot (1).svg",
                "room_categories": [
                    "kitchen",
                    "office",
                    "reception_area",
                    "main_workspace",
                    "dining-room"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35356,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "TV",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 7742,
            "name": "TV",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 598,
                "name": "TV",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": [
                    "front-yard",
                    "bathroom",
                    "laundry",
                    "front_yard",
                    "garage",
                    "bedroom",
                    "backyard",
                    "back_yard",
                    "living_room",
                    "hallway",
                    "stairwell",
                    "kitchen",
                    "reception_area",
                    "patio",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35361,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Air Conditioner",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5142,
            "name": "Air Conditioner",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 414,
                "name": "Air Conditioner",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/air-conditioner.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    },
    {
        "id": 35352,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Light Bulb",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 10007,
            "name": "Light Bulb",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 744,
                "name": "Light Bulb",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/light-bulb (1).svg",
                "room_categories": [
                    "backyard",
                    "back_yard",
                    "bathroom",
                    "bedroom",
                    "dining_room",
                    "dining-room",
                    "front_yard",
                    "front-yard"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35369,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Table",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 4954,
            "name": "Table",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 249,
                "name": "Table",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/table.svg",
                "room_categories": []
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    },
    {
        "id": 35390,
        "address_id": 623530,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Microwave",
        "min_quantity": 12,
        "current_quantity": 13,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 7623,
            "name": "Microwave",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 599,
                "name": "Microwave",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/microwave.svg",
                "room_categories": [
                    "front-yard",
                    "bathroom",
                    "laundry",
                    "front_yard",
                    "garage",
                    "bedroom",
                    "backyard",
                    "back_yard",
                    "living_room",
                    "hallway",
                    "stairwell",
                    "kitchen",
                    "reception_area",
                    "patio",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623530,
            "address1": "Champions Avenue",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89142",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 152,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 9,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Main Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1441714,
            "longitude": -115.0610809,
            "created_at": "2024-07-24T21:38:38Z",
            "updated_at": "2025-03-06T20:02:55Z"
        }
    },
    {
        "id": 35357,
        "address_id": 623549,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Monitor",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 10009,
            "name": "Monitor",
            "model": null,
            "kind": "specific",
            "category": {
                "id": 778,
                "name": "Monitor",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": [
                    "backyard",
                    "back_yard",
                    "bathroom",
                    "bedroom",
                    "dining_room",
                    "dining-room",
                    "front_yard",
                    "front-yard",
                    "garage"
                ]
            }
        },
        "address": {
            "id": 623549,
            "address1": "The Signature at MGM Grand - Tower B",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89109",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 2,
            "bath_count": 1,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1067937,
            "longitude": -115.1665441,
            "created_at": "2024-07-24T21:38:51Z",
            "updated_at": "2024-07-24T21:38:51Z"
        }
    },
    {
        "id": 35360,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Monitor",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5141,
            "name": "Monitor",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 413,
                "name": "Monitor",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    },
    {
        "id": 35358,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Refrigerator",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 10009,
            "name": "Refrigerator",
            "model": null,
            "kind": "specific",
            "category": {
                "id": 778,
                "name": "Refrigerator",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/svgs/refrigerator (1).svg",
                "room_categories": [
                    "backyard",
                    "back_yard",
                    "bathroom",
                    "bedroom",
                    "dining_room",
                    "dining-room",
                    "front_yard",
                    "front-yard",
                    "garage"
                ]
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    },
    {
        "id": 35364,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Vacuum",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5211,
            "name": "Vacuum",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 412,
                "name": "Vacuum",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/vacuum.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    },
    {
        "id": 35372,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "Glass / Cup",
        "min_quantity": 8,
        "current_quantity": 9,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 5600,
            "name": "Glass / Cup",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 416,
                "name": "Glass / Cup",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/glass-of-water.svg",
                "room_categories": [
                    "kitchen",
                    "hallway",
                    "living_room",
                    "bedroom",
                    "garage",
                    "laundry",
                    "dining_room",
                    "bathroom",
                    "main_workspace",
                    "dining-room",
                    "reception_area",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    },
    {
        "id": 35382,
        "address_id": 623552,
        "state": "active",
        "installation_date": "2024-01-01",
        "description": null,
        "name": "TV",
        "min_quantity": 1,
        "current_quantity": 2,
        "low_quantity_alert": false,
        "item_cost": null,
        "max_quantity": null,
        "opportunistic_quantity": null,
        "min_restocking_price": null,
        "max_restocking_price": null,
        "where_to_order": null,
        "delivery_timing_preference": null,
        "restocking_notes": null,
        "photo_url": null,
        "model": {
            "id": 7742,
            "name": "TV",
            "model": null,
            "kind": "generic",
            "category": {
                "id": 598,
                "name": "TV",
                "default_icon_url": "https://d30thx9uw6scot.cloudfront.net/tv.svg",
                "room_categories": [
                    "front-yard",
                    "bathroom",
                    "laundry",
                    "front_yard",
                    "garage",
                    "bedroom",
                    "backyard",
                    "back_yard",
                    "living_room",
                    "hallway",
                    "stairwell",
                    "kitchen",
                    "reception_area",
                    "patio",
                    "office"
                ]
            }
        },
        "address": {
            "id": 623552,
            "address1": "4200 South Valley View Boulevard",
            "address2": null,
            "city": "Las Vegas",
            "add_state": "NV",
            "country_code": "US",
            "zip": "89103",
            "state": "active",
            "home_access": "",
            "home_close": null,
            "region_id": 154,
            "general_instructions": null,
            "hk_notes": null,
            "bed_count": 3,
            "bath_count": 2,
            "floors_amount": 1,
            "paid_parking": null,
            "parking_spot": null,
            "parking_pay_with": null,
            "max_parking_cost": null,
            "parking_notes": null,
            "office_size": null,
            "office_type": null,
            "address_name": "Branch Office",
            "average_nightly_rate": null,
            "average_stay": null,
            "average_bookings": null,
            "latitude": 36.1126358,
            "longitude": -115.187581,
            "created_at": "2024-07-24T21:38:53Z",
            "updated_at": "2024-07-24T21:38:53Z"
        }
    }
]
